import * as React from 'react';
import "./radioButton.scss";

const classNames = require('classnames');
const uuidv4 = require('uuid/v4');

export interface IRadioButton {
	/**
	 * Radio button label
	 */
	label: string | JSX.Element;
	/**
	 * Radio button value
	 */
	value: string;
	/**
	 * Indicates if radio button is disabled
	 */
	disabled: boolean;
}

interface Props {
	/**
	 * Radio button
	 */
	radioButton: IRadioButton;
	/**
	 * On change callback.
	 * @param {boolean} checked value
	 * @param {RadioButtonOption} which option is selected
	 */
	onChange: (checked: boolean, option: IRadioButton) => void;
	/**
	 * Whether is selected
	 */
	checked: boolean;
	/**
	 * On focus change
	 * @returns {any}
	 */
	onFocus?: () => any;
}

export default class RadioButton extends React.Component<Props> {
	public static defaultProps: Partial<Props> = {
		radioButton: {
			label: '',
			value: '',
			disabled: true,
		},
		checked: false,
		onChange: () => {
		},
	};

	/**
	 * Unique radios name.
	 */
	inputRadiosName = uuidv4();

	render() {
		const classFromProps = classNames({
			"a-radio-button": true,
			"is-disabled": this.props.radioButton.disabled,
		});
		return (
			<div className={classFromProps}>
				<label tabIndex={0}>
					<input onFocus={this.props.onFocus}
						   type="radio"
						   name={this.inputRadiosName}
						   disabled={this.props.radioButton.disabled}
						   tabIndex={-1}
						   value={this.props.radioButton.value}
						   checked={this.props.checked}
						   onChange={evt => this.props.onChange(evt.currentTarget.checked, this.props.radioButton)}/>
					{this.props.radioButton.label}
					<span/>
				</label>
			</div>
		);
	}
}